import { render, staticRenderFns } from "./public-detail.vue?vue&type=template&id=75ceb73a&"
import script from "./public-detail.js?vue&type=script&lang=js&"
export * from "./public-detail.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports